/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const ChimeC = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.6263 22C7.36955 22 3 17.8878 3 12C3 9.03157 4.04976 6.49108 6.03625 4.65405C7.88638 2.94241 10.4065 2 13.1328 2C14.4972 2 15.6621 2.23487 16.79 2.46215C17.8665 2.67948 18.8836 2.88439 20.0154 2.88439C20.3516 2.88439 20.6743 2.86671 21 2.83046V7.26659C20.6031 7.32286 20.2189 7.35034 19.8258 7.35034C18.5676 7.35034 17.5213 7.05656 16.509 6.772C15.53 6.49839 14.6054 6.23955 13.5442 6.23955C10.2702 6.23955 7.9836 8.52602 7.9836 11.7998C7.9836 15.2393 10.4905 17.6412 14.0797 17.6412C16.324 17.6412 18.8425 16.6912 21 15.0326V19.6633C19.5436 20.7315 17.0856 22 13.6263 22Z"
                        fill={color}
                    />
                </svg>
        );
    };
